// filterView/filterView.js — controller of the documents.php filter views (plan documents_admin-search, phase
// filter-client): one store with the condition list for all variant tabs, every change written into the hidden fv.
//
//   const view = createFilterView({ schema, input });          // input = <input type="hidden" name="fv">
//   view.mount(createChipsView, panelA); view.mount(createFormView, panelC);
//
// Variants are mounted at once, each into its own tab panel (tabs.js only shows / hides), so switching tabs keeps
// the filter. Variant contract: createXView({ schema, store, options }) → { element, destroy }; a variant changes the
// list only through the store (store.set(s => updateCondition(s, schema, id, patch)) …).
//
// Returns { store, problems, mount, destroy }; `problems` = what fromParam dropped from the submitted fv (the views
// mark them), see conditionSet.fromParam.

import { createStore } from '../core/store.js';
import { createDisposers } from '../core/disposers.js';
import { fromParam, toParam } from './conditionSet.js';

export function createFilterView({ schema, input, initial = input.value }) {
    const disposers = createDisposers();
    const { set, problems } = fromParam(initial, schema);
    const store = createStore(set);

    const write = (current) => { input.value = toParam(current, schema); };
    write(set);
    disposers.add(store.subscribe(write));

    return {
        store,
        problems,
        // Builds a variant into `element`; returns the variant.
        mount(createVariant, element, options = {}) {
            const variant = createVariant({ schema, store, options });
            element.appendChild(variant.element);
            disposers.add(() => {
                variant.destroy();
                variant.element.remove();
            });
            return variant;
        },
        destroy() {
            disposers.dispose();
        },
    };
}
